import React from 'react'
import DocumentIcon from './icons/DocumentIcon'
import ChevronIcon from './icons/ChevronIcon'

const DocumentPreview = ({document}) => {
    const documentType = document.url.split('/').pop().split('.').pop()
    return (
        <div className='w-full border border-gray-300 rounded-[8px] p-3 flex items-center gap-x-2 transition duration-300 hover:shadow-lg'>
            <div className=' relative'>
                <DocumentIcon className={`w-12 h-12 text-gray-500`} />
                <p className='px-[5px] py-[2px] text-[10px] uppercase text-white inline bg-gray-600 absolute bottom-[10px] -left-[2px]'>{documentType}</p>
            </div>
            <div className='w-full'>
                <p className='text-sm'>{document.name}</p>
                <a href={document.url} target='_blank' rel="noreferrer" className='text-gray-400 hover:text-vcm-purple transition duration-200 text-xs flex items-center gap-x-2'>View/download document <ChevronIcon className={`w-4 h-4 rotate-180`} /></a>
            </div>
        </div>
  )
}

export default DocumentPreview